import 'js-offcanvas/dist/_js/js-offcanvas.pkgd';
import { Controller } from "stimulus";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  activeBoxClass = 'active-box';

  connect() {
    this.filterBtn = this.element.querySelector('.filter-button');
    this.filterBtn.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.activateInput();
      this.updateInput();
    });

    this.element.querySelector('.close-button').addEventListener('click', () => {
      this.activeInput(false);
      this.closeMobilePageFilter();
    });

    this.offCanvas();
    this.bindInputSearchEvents();
    this.bindFormTarget();
  }

  offCanvas() {
    if (!this.element.dataset.offcanvasTarget || this.isMobile())
      return;

    $('#filters-canvas').offcanvas({
      modifiers: 'left, overlay',
      triggerButton: `#${this.filterBtn.id}`
    });

    if (!this.targetOffCanvas)
      this.targetOffCanvas = $(this.element.dataset.offcanvasTarget).data('offcanvas-component');
  }

  updateInput(delay = 1000) {
    if (this.isMobile())
      return;

    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.activeInput(true /*this.inputSearch.value.length > 0*/);
      this.updateInputSearchIntoForm();
    }, delay);
  }

  activeInput(state) {
    this.element.classList.toggle(this.activeBoxClass, state);
    this.inputSearch.classList.toggle('active-input', state);
  }

  activateInput() {
    this.activeInput(true);
  }

  onInputSearchClick() {
    this.isMobile() && this.openMobilePageFilter();
    this.activateInput();
    this.inputSearch.focus();
  }

  openMobilePageFilter() {
    this.toggleMobilePageFilter(true);
  }

  closeMobilePageFilter() {
    this.toggleMobilePageFilter(false);
  }

  toggleMobilePageFilter(state) {
    let offCanvas = document.querySelector(this.element.dataset.offcanvasTarget);

    if (!offCanvas)
      return;

    offCanvas.classList.toggle('mobile-open-menu-filter', state);
    document.body.classList.toggle('overflow-hidden', state);

    if (!state)
      return;

    let mobilePageAction = document.querySelector('#collapse-mobile-page-action');
    !!mobilePageAction && mobilePageAction.classList.toggle('show', false);
  }

  bindInputSearchEvents() {
    this.inputSearch = this.element.querySelector('.search-input');
    this.inputSearch.addEventListener('click', () => this.onInputSearchClick());
    this.inputSearch.addEventListener('focus', () => { clearTimeout(this.timeout) });

    ['blur', 'change'].forEach((ev) => {
      this.inputSearch.addEventListener(ev, () => { this.updateInput() });
    });

    this.updateInput(400 /* 400ms */);
  }

  bindFormTarget() {
    this.form = document.querySelector(this.element.dataset.formTarget);

    if (!this.form)
      return;

    $(this.inputSearch).on('keydown',  (ev) => {
      (ev.code === 'NumpadEnter' || ev.code === 'Enter') && this.submitForm(ev)
    });

    this.element.querySelector('.search-button').addEventListener('click', (ev) => {
      ev.preventDefault();

      if (this.isOpened())
        return this.submitForm(ev);

      this.onInputSearchClick()
    });
  }

  submitForm(ev) {
    ev.preventDefault();
    AjaxLoader.show();

    this.updateInputSearchIntoForm();
    this.form.requestSubmit();
  }

  updateInputSearchIntoForm() {
    if (!this.form)
      return;

    [...this.form.querySelectorAll('#search-input-clone')].forEach((it) => it.remove());

    if (!!this.inputSearch.value)
      this.form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="${this.inputSearch.name}" value="${this.inputSearch.value}" id="search-input-clone" />`);
  }

  isOpened() {
    return this.element.classList.contains(this.activeBoxClass);
  }

  isMobile() {
    return this.element.classList.contains('mobile-search');
  }
};